import type { IUser } from '@/features/auth/interfaces';

/** Display helpers shared by the user picker and read-only user values. */

export function getUserDisplayName(user: IUser): string {
    return [user.firstName, user.lastName].filter(Boolean).join(' ') || user.email;
}

export function getUserInitials(user: IUser): string {
    const initials = `${user.firstName.charAt(0)}${user.lastName.charAt(0)}`.toUpperCase();
    return initials || user.email.charAt(0).toUpperCase();
}
